module.exports = __webpack_public_path__ + "media/images/exclamation-faeea3c67341532fee852cbeef01ab98.svg";